﻿import {
	ParkingPrebookingAvailabilityEntry,
	SelectedParkingPrebookingAvailabilityEntry
} from "@2d-front-monorepo/permits-business";
import {PayWith} from "../index";
import {TariffId} from "../nominalTypes/TariffId";
import {ZoneId} from "../nominalTypes/ZoneId";
import {GetParkingOperationStepsArguments} from "../types/arguments/GetParkingOperationStepsArguments";
import {MultiOperationPermit} from "./MultiOperationPermit";

export type DailyWeatherPermitData = {
	availability: ParkingPrebookingAvailabilityEntry[]
}

type DailyWeatherPermitDataInternal = {
	data: DailyWeatherPermitData,
	operations: MultiOperationPermit
}

export class DailyWeatherPermit {
	private static _map: WeakMap<DailyWeatherPermitData, DailyWeatherPermitDataInternal> = new WeakMap();

	public static empty(): DailyWeatherPermitData {
		const data: DailyWeatherPermitData = {
			availability: []
		};

		this._map.set(data, {
			data,
			operations: new MultiOperationPermit(data.availability)
		});

		return data;
	}

	static getParkingOperationArguments(data: DailyWeatherPermitData, tariffId: TariffId, zoneId: ZoneId, plates: string[]): GetParkingOperationStepsArguments {
		const selected = this.getSelected(data);

		return {
			startDate: selected[0].startDate,
			endDate: selected.at(-1)!.endDate,
			tariffId: tariffId,
			branch: {zoneId: zoneId},
			deferConfirmation: false,
			licensePlates: plates,
			payWith: PayWith.DebitCreditCard,
			preBookingEntries: data.availability,
			selectedPreBookingEntries: selected
		}
	}

	static getSelected(data: DailyWeatherPermitData): SelectedParkingPrebookingAvailabilityEntry[] {
		return this._getInternalData(data).operations.getSelected();
	}

	static isValid(data: DailyWeatherPermitData): boolean {
		return this._getInternalData(data).operations.size > 0;
	}

	static setSelectedEntries(data: DailyWeatherPermitData, selected: number[]): void {
		const d = this._getInternalData(data);
		d.operations.clear();

		if (selected.length === 0) {
			return;
		}

		for (const index of selected) {
			const entry = d.data.availability[index];
			d.operations.tryCreateSegment(entry.startDate, entry.endDate)
		}
	}

	public static update(data: DailyWeatherPermitData, availability: ParkingPrebookingAvailabilityEntry[]): void {
		const d = this._getInternalData(data);
		d.data.availability = availability;
		d.operations = new MultiOperationPermit(availability);
	}

	private static _getInternalData(data: DailyWeatherPermitData): DailyWeatherPermitDataInternal {
		return this._map.get(data)!;
	}

	// static getEndDate(data: DailyWeatherPermitData): DateOnly | undefined {
	// 	const s = this.getSelected(data);
	// 	return s.length === 0 ? undefined : s.at(-1)!.endDate.toDateOnly();
	// }

	// static getStartDate(data: DailyWeatherPermitData): DateOnly | undefined {
	// 	const s = this.getSelected(data);
	// 	return s.length === 0 ? undefined : s[0].startDate.toDateOnly();
	// }
}
